import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DoctorLayout from "@/pages/doctor/DoctorLayout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import ConsultationContent from "@/components/ConsultationContent";

export default function ConsultationPage() {
  const { patientId, appointmentId } = useParams();
  const navigate = useNavigate();
  const [patient, setPatient] = useState(null);

  useEffect(() => {
    api.get(`/patients/${patientId}`).then(({ data }) => setPatient(data));
  }, [patientId]);

  if (!patient) return <DoctorLayout><p className="text-slate-500">Loading...</p></DoctorLayout>;

  return (
    <DoctorLayout>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900" data-testid="consultation-heading">
            AI Consultation Assistant
          </h1>
          <p className="text-sm text-slate-500">
            {patient.full_name} · <span className="font-mono">{patient.patient_code}</span> · Age {patient.age || "—"}
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate(`/doctor/patients/${patientId}`)}>Back to Profile</Button>
      </div>

      <div className="mt-6">
        <ConsultationContent patientId={patientId} appointmentId={appointmentId} patient={patient} />
      </div>
    </DoctorLayout>
  );
}
